const types = {
	//Get Template name
	GET_CLIENT_PROJECTS_START: "GET_CLIENT_PROJECTS_START",
	GET_CLIENT_PROJECTS_SUCCESS: "GET_CLIENT_PROJECTS_SUCCESS",
	GET_CLIENT_PROJECTS_ERROR: "GET_CLIENT_PROJECTS_ERROR",
	GET_CLIENT_PROJECTS_RESET: "GET_CLIENT_PROJECTS_RESET",

	//Create Template name
	CREATE_CLIENT_PROJECTS_START: "CREATE_CLIENT_PROJECTS_START",
	CREATE_CLIENT_PROJECTS_SUCCESS: "CREATE_CLIENT_PROJECTS_SUCCESS",
	CREATE_CLIENT_PROJECTS_ERROR: "CREATE_CLIENT_PROJECTS_ERROR",
	CREATE_CLIENT_PROJECTS_RESET: "CREATE_CLIENT_PROJECTS_RESET",

	//delete Template name
	DELETE_CLIENT_PROJECTS_START: "DELETE_CLIENT_PROJECTS_START",
	DELETE_CLIENT_PROJECTS_SUCCESS: "DELETE_CLIENT_PROJECTS_SUCCESS",
	DELETE_CLIENT_PROJECTS_ERROR: "DELETE_CLIENT_PROJECTS_ERROR",
	DELETE_CLIENT_PROJECTS_RESET: "DELETE_CLIENT_PROJECTS_RESET",

	//update Template name
	UPDATE_CLIENT_PROJECTS_START: "UPDATE_CLIENT_PROJECTS_START",
	UPDATE_CLIENT_PROJECTS_SUCCESS: "UPDATE_CLIENT_PROJECTS_SUCCESS",
	UPDATE_CLIENT_PROJECTS_ERROR: "UPDATE_CLIENT_PROJECTS_ERROR",
	UPDATE_CLIENT_PROJECTS_RESET: "UPDATE_CLIENT_PROJECTS_RESET",

	//single item  name
	SINGLE_CLIENT_PROJECTS_START: "SINGLE_CLIENT_PROJECTS_START",
	SINGLE_CLIENT_PROJECTS_SUCCESS: "SINGLE_CLIENT_PROJECTS_SUCCESS",
	SINGLE_CLIENT_PROJECTS_ERROR: "SINGLE_CLIENT_PROJECTS_ERROR",
	SINGLE_CLIENT_PROJECTS_RESET: "SINGLE_CLIENT_PROJECTS_RESET",
};

export default types;
